export default {
  getOrdersLength: (_state: any) => Object.keys(_state.orders.data).length,
};
